const expenses = (expenses = [], action) => {
  switch (action.type) {
    case 'FETCH_EXPENSES':
      return action.payload
    default:
      return expenses
  }
}
export default expenses
